import React, { useState, useEffect } from "react";
import Parser from "html-react-parser";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
//import RecordNotFound from "../../../common/RecordNotFound";
import RecordNotFoundNoNewNotification from "../../../common/RecordNotFoundNoNewNotification";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import DownloadIcon from "@mui/icons-material/Download";
import { DownloadBroadcastService } from "../../../services/NotificationService";
import { useLoading } from "../../../common/LoadingContext";
import { useNotificationContext } from "../../../common/NotificationContext";
import download from "downloadjs";
const BroadCast = (props) => {
  const {
    notificationRecords,
    totalElements,
    handleChangePage,
    handleChangeRowsPerPage,
    rowsPerPage,
    page,
    setBraodCastLength,
    noRecord,
    handleMoveToReadFunc,
  } = props;
  const [brodcastList, setBrodcastList] = useState([]);
  const [prevLocalIds, setPrevLocalIds] = useState([]);
  const [ids, setIds] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();

  useEffect(() => {
    setBrodcastList(notificationRecords);
  }, [
    notificationRecords,
    totalElements,
    handleChangePage,
    handleChangeRowsPerPage,
    rowsPerPage,
    page,
    setBraodCastLength,
    handleMoveToReadFunc,
  ]);
  useEffect(() => {
    var localFields = JSON.parse(localStorage.getItem("notifyBroadCast"));

    if (localFields) {
      setIds(localFields);
    }
  }, []);

  const handleChange = (id) => (_, isExpanded) => {
    setExpanded(isExpanded ? id : null);
    setShowMore(false);
  };
  // download broadcast
  const handleDownload = async (id) => {
    try {
      setLoading(true);
      const response = await DownloadBroadcastService(id);
      if (response) {
        const content = response.headers["content-type"];
        const [, filename] = response.headers['content-disposition'].split('filename=');
        const withoutFirstAndLast = filename.slice(1, -1);
        download(response.data, withoutFirstAndLast, content);
        showNotification("Success", "Succesfully Downloaded", "success");
      } else {
        showNotification("Error", response?.message ?? "Failed to download");
      }
    } catch (err) {
      console.log("err", err);

      showNotification("Error", "Failed to download");
    } finally {
      setLoading(false);
    }
  };

  const handleClickTitle = (id) => {
    var localFields = JSON.parse(localStorage.getItem("notifyBroadCast"));
    setPrevLocalIds(localFields);

    if ((ids.indexOf(id) || localFields?.includes(id)) !== -1) {
    } else {
      ids.push(id);
      localStorage.setItem("notifyBroadCast", JSON.stringify(ids));
      setBraodCastLength(ids);
    }
  };
  return (
    <>
      {brodcastList && brodcastList.length > 0 ? (
        brodcastList
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <>
                <Accordion
                  onChange={handleChange(row.id)}
                  expanded={expanded === row.id}
                  className={
                    localStorage.getItem("notifyBroadCast")?.includes(row.id) ||
                    prevLocalIds?.includes(row.id)
                      ? "checkedNotification"
                      : ""
                  }
                  sx={{
                    borderLeft: 7,
                    p: 0,
                    borderColor: "#003f93",
                    mb: 1,
                    textAlign: "left",
                  }}
                  key={row.id}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    onClick={() => {
                      handleClickTitle(row.id);
                      handleMoveToReadFunc("0", row.id);
                    }}
                    className="notification_title broadcastDownloadWraper">
                    <Typography sx={{ textTransform: "capitalize" }}>
                      {row.title}{" "}
                    </Typography>
                    {/* {row.downloadable ? }  */}
                    {row?.downloadable ? (
                      <span
                        className="broadcastDownload"
                        onClick={() => handleDownload(row.id)}>
                        <DownloadIcon />{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </AccordionSummary>
                  <AccordionDetails className="brodcastNotificationBlock">
                    <Typography className="tablecontent">
                      {row?.content.startsWith('"')
                        ? showMore
                          ? Parser(JSON.parse(row?.content))
                          : Parser(JSON.parse(row?.content).substring(0, 122))
                        : showMore
                        ? row?.content
                        : row?.content.substring(0, 10)}
                        {row?.content.length > 122 ? (
                      <button
                        className="showMore"
                        onClick={() => setShowMore(!showMore)}>
                        {showMore ? "Show less" : "Show more"}{" "}
                        <KeyboardDoubleArrowRightIcon />
                        </button>): ""}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </>
            );
          })
      ) : noRecord ? (
        <RecordNotFoundNoNewNotification />
      ) : null}
    </>
  );
};

export default BroadCast;
